import { render } from "./PfInputTime.vue?vue&type=template&id=49b5c12f"
import script from "./PfInputTime.vue?vue&type=script&lang=js"
export * from "./PfInputTime.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__